import debounce from 'lodash/debounce';
import getPdfViewerApplication from './pdfViewerApplication';
import { trackAdobeEvent } from '../trackers/adobe';
import { SEARCH_FOUND, SEARCH_NOT_FOUND } from '../../../shared/actions/types';
import { DIRECTION } from '../../constants';

const searchStateMap = {
  SEARCH_FOUND: 0,
  SEARCH_NOT_FOUND: 1,
  SEARCH_WRAPPED: 2,
};

const oldSearchState = {};

function trackSearchInAdobe(totalResults) {
  const currentQuery = getPdfViewerApplication().findApi.getFindQuery();
  if (!currentQuery || currentQuery === oldSearchState.query) {
    // State change was a cancel search or navigation
    oldSearchState.query = currentQuery;
    return;
  }
  oldSearchState.query = currentQuery;
  trackAdobeEvent('searchResultsUpdated', {
    search: {
      criteria: currentQuery,
      type: 'er:implicit:keyword search',
      withinContentCriteria: currentQuery,
      totalResults,
    },
  });
}

const debouncedSearchFound = debounce((dispatch) => {
  const { matchCount, currentMatch } = getPdfViewerApplication().findApi.getFindResultCounts();

  trackSearchInAdobe(matchCount);

  return dispatch({
    type: SEARCH_FOUND,
    payload: { matchCount, currentMatch },
  });
}, 100);

export const onUpdateFindControlState = (dispatch, event) => {
  const { state } = event;
  if (state === searchStateMap.SEARCH_FOUND || state === searchStateMap.SEARCH_WRAPPED) {
    return debouncedSearchFound(dispatch);
  } if (state === searchStateMap.SEARCH_NOT_FOUND) {
    trackSearchInAdobe(0);
    return dispatch({ type: SEARCH_NOT_FOUND });
  }

  return null;
};

export default class FindApi {
  constructor() {
    this.pdfFindController = null;
    this.eventBus = null;
  }

  init(pdfFindController, eventBus) {
    this.pdfFindController = pdfFindController;
    this.eventBus = eventBus;
  }

  executeFindCommand(type, query, direction) {
    this.eventBus.dispatch('find', {
      type,
      query,
      phraseSearch: true,
      highlightAll: true,
      findPrevious: direction === DIRECTION.DESC,
    });
  }

  find(query, direction) {
    this.executeFindCommand('', query, direction);
  }

  findNext(query) {
    this.executeFindCommand('again', query, DIRECTION.ASC);
  }

  findPrevious(query) {
    this.executeFindCommand('again', query, DIRECTION.DESC);
  }

  cancelFind() {
    this.executeFindCommand('', '');
  }

  getFindQuery() {
    return this.pdfFindController.state.query;
  }

  getFindResultCounts() {
    const {
      pageMatches = [],
      selected: {
        pageIdx = -1,
        matchIdx = -1,
      },
    } = this.pdfFindController;

    let currentMatch = matchIdx;
    let matchCount = 0;

    if (pageIdx >= 0 && matchIdx >= 0) {
      currentMatch = matchIdx + 1;

      for (let i = 0; i <= pageMatches.length - 1; i += 1) {
        if (i < pageIdx) {
          currentMatch += pageMatches[i].length;
        }

        matchCount += pageMatches[i].length;
      }
    }

    return { currentMatch, matchCount };
  }
}
